export default __webpack_public_path__ + "static/media/Mobile.5a025390.svg";